"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @private
 */
exports.AVAILABILITY_ENDPOINT = {
    getAvailability: '/carsharing/{{version}}/availability?profile_uuid={{userProfileUuid}}&city_uuid={{cityUuid}}&booking_type={{bookingType}}&start={{start}}&end={{end}}',
};
